module.exports = __webpack_public_path__ + "img/pcbanner_id_ID.8ebc8d8d.jpg";